module.exports = __webpack_public_path__ + "img/page-06.86573948.jpg";